import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getBusinessMaster } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetBusinessMasterRequestSchema,
  type GetBusinessMasterResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

export function useGetBusinessMaster(
  id: string,
): UseQueryResult<GetBusinessMasterResponse, ConnectError> {
  return useQuery(
    getBusinessMaster,
    create(GetBusinessMasterRequestSchema, { id }),
    { enabled: id !== '' },
  )
}
